var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('integration-tasks-table',{attrs:{"integration-id":_vm.model.id,"task-identifiers":[
      'optimove_attributes_sync',
      'optimove_campaign_execute',
      'optimove_campaign_pre_execute',
      'optimove_suppression_attributes_sync',
      'optimove_suppression_attributes_import',
      'optimove_list_update'
    ]}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b705d3ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/integrations/types/optimove/OptimoveTasks.vue
// module id = null
// module chunks = 